import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { profileType } from "@utils/enum";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "teu", label: "Total TEUs", two_table_header: "Total TEUs" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "teu", label: "TEUs", table_header: "Total TEU" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "US Exports",
  showFacilityFilter: true,
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  autosuggestLang: "EN",
  analyticsRangeDownloadPresent: true,
  isHandleTrademoAccount: true,
  isShipmentGridNew: true,
  isViewAllGridNew: true,
  oldPayloadType: true,
  showUiTrends: true,
  isUIGridNew: true,
  isUEGridNew: true,
  // isDataInPdfDownload: true,
  isViewShipmentURLModified: true,
  date: "departure_date",
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  exportPDFInAnalytics: false,
  exportPDFInAnalyticsFrontend: true,
  minimumDateAllowed: "2014-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
    logistic: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "teu", label: "TEUs", table_header: "Total TEU" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Value (USD)" },
  ],
  logistics_sort_option: [{ value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" }],
  apiEndPoints: {
    getArrivalDate: getApiUrl("getLatestArrivalDateUSExports"),
    getSearchResult: getApiUrl("getUSExportsSearchResults"),
    getAnalyticsData: getApiUrl("analytics/analyticsUSExports"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_us_exports"),
    downloadUniqueImporterExporter: getApiUrl("createExcelExporter"),
    getShipmentByID: getApiUrl("getUSExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfUsExport"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/analyticsUSExportsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.us_export.country_small,
  countryCaps: globalCountryDetails.us_export.country_caps,
  product_id: globalCountryDetails.us_export.product_id,
  compare_product_id: globalCountryDetails.us_export.compareProduct,
  country_CamelCase: globalCountryDetails.us_export.product_id,
  countryCode: globalCountryDetails.us_export.countryCode,
  countryType: globalCountryDetails.us_export.countryType,
  manyCountryType: globalCountryDetails.us_export.manyCountryType,
  countryTypeCode: globalCountryDetails.us_export.countryTypeCode,
  redirectionID: globalCountryDetails.us_export.redirectionID,
  analyticsCountryID: globalCountryDetails.us_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Departure Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    logistics: true,
    whatYouAreMissing: true,
    reports: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
    logistics: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.us_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    proximity: "shipper_zipcode",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortRegion",
    vocc: "standardVoccName",
    nvocc: "standardNvoccName",
    freightForwarder: "standardFreightForwarderName",
    tradeLane: "standardTradeLane",
    productCategory: "productCategory",
  },
  filterObj: {
    derived_country_of_destination_region: "derived_country_of_destination_region",
    countryOfExportRegion: "countryOfExportRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    is_enriched_data: "is_enriched_data",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    standardLadingPortRegion: "standardLadingPortRegion",
    is_supplier: "is_supplier",
    shipper_name: "shipper_name",
    derived_shipper_state_region: "derived_shipper_state_region",
    shipper_city: "shipper_city",
    shipper_zipcode: "shipper_zipcode",
    carrier_name: "carrier_name",
    standardVoccName: "standardVoccName",
    standardNvoccName: "standardNvoccName",
    standardFreightForwarderName: "standardFreightForwarderName",
    weight: "weight",
    teu: "teu",
    hsCode: "hsCode",
    containers: "containers",
    aes_dis: "aes_dis",
    shipmentValue: "shipmentValue",
    derivedShipperMasterName: "derivedShipperMasterName",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    sixDigitHsCode: "sixDigitHsCode",
    vesselType: "vesselType",
    vesselTypeRegion: "vesselTypeRegion",
    standardTradeLane: "standardTradeLane",
    transportation: "transportation",
    shipperFacility: "shipperFacility",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {
    is_enriched_data: "is_enriched_data",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    containers: "containers",
    shipmentValue: "shipmentValue",
    weight: "weight",
    teu: "teu",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    containers: [],
    shipmentValue: [],
    weight: [],
    teu: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    standardLadingPortRegion: "standardLadingPortName",
    derived_shipper_state_region: "shipper_state",
    derived_country_of_destination_region: "derived_country_of_destination",
    countryOfExportRegion: "countryOfExport",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
    standardUnladingPortRegion: "standardUnladingPortName",
    vesselTypeRegion: "vesselType",
  },
  emptyFilterObj: {
    derived_country_of_destination_region: [],
    countryOfExportRegion: [],
    shipperJurisdictionCountryRegion: [],
    standardUnladingPortRegion: [],
    standardLadingPortRegion: [],
    is_supplier: [],
    shipper_name: [],
    derived_shipper_state_region: [],
    shipper_city: [],
    shipper_zipcode: [],
    carrier_name: [],
    standardVoccName: [],
    standardNvoccName: [],
    standardFreightForwarderName: [],
    weight: [],
    teu: [],
    hsCode: [],
    containers: [],
    aes_dis: [],
    sections: [],
    shipmentValue: [],
    is_enriched_data: [],
    derivedShipperMasterName: [],
    productCategory: [],
    industryCategory: [],
    sixDigitHsCode: [],
    vesselType: [],
    vesselTypeRegion: [],
    standardTradeLane: [],
    transportation: [],
    shipperFacility: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    is_enriched_data: true,
    exclude_blank_shipper: false,
  },
  selectAll: {
    derived_country_of_destination_region: false,
    countryOfExportRegion: false,
    shipperJurisdictionCountryRegion: false,
    standardUnladingPortRegion: false,
    standardLadingPortRegion: false,
    is_supplier: false,
    shipper_name: false,
    derived_shipper_state_region: false,
    shipper_city: false,
    shipper_zipcode: false,
    carrier_name: false,
    standardVoccName: false,
    standardNvoccName: false,
    standardFreightForwarderName: false,
    weight: false,
    teu: false,
    hsCode: false,
    containers: false,
    aes_dis: false,
    sections: false,
    shipmentValue: false,
    derivedShipperMasterName: false,
    productCategory: false,
    industryCategory: false,
    sixDigitHsCode: false,
    vesselType: false,
    vesselTypeRegion: false,
    standardTradeLane: false,
    transportation: false,
    shipperFacility: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "22", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "5", key: "shipper_name", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search Shipper Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "1", altKey: "derived_country_of_destination", key: "derived_country_of_destination_region", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search Country of Import", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "1", altKey: "countryOfExport", key: "countryOfExportRegion", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search Country of Export", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: "shipperDetails", eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Unlading", categoryName: "ports", eventKey: "2", altKey: "standardUnladingPortName", key: "standardUnladingPortRegion", type: filterType.localizeFilter, label: "Port of Unlading", viewAllPlaceHolder: "Search Port of Unlading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Lading", categoryName: "ports", eventKey: "3", altKey: "standardLadingPortName", key: "standardLadingPortRegion", type: filterType.localizeFilter, label: "Port of Lading", viewAllPlaceHolder: "Search Port of Lading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "4", key: "is_supplier", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", mappedValues: { N: "Logistics Provider", Y: "Supplier" }, showInput: false },
    { heading: "Filter by Shipper State", categoryName: "shipperDetails", eventKey: "6", altKey: "shipper_state", key: "derived_shipper_state_region", type: filterType.localizeFilter, label: "Shipper State", viewAllPlaceHolder: "Search Shipper State", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper City", categoryName: "shipperDetails", eventKey: "7", key: "shipper_city", type: filterType.normalFilter, label: "Shipper City", viewAllPlaceHolder: "Search Shipper City", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Zipcode", categoryName: "shipperDetails", eventKey: "8", key: "shipper_zipcode", type: filterType.proximityFilter, label: "Shipper Zipcode", viewAllPlaceHolder: "Search Shipper Zipcode", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Carrier", categoryName: "carrierDetails", eventKey: "9", key: "carrier_name", type: filterType.normalFilter, label: "Carrier", viewAllPlaceHolder: "Search Carrier", emptyFilterText: "", searchFilterString: "", isParanthesesCapital: true },
    { heading: "Filter by VOCC", categoryName: "carrierDetails", eventKey: "10", key: "standardVoccName", type: filterType.normalFilter, label: "VOCC", viewAllPlaceHolder: "Search VOCC Name", emptyFilterText: "", searchFilterString: "", isFavourite: true, profileTypeKey: profileType.logistics, isParanthesesCapital: true },
    { heading: "Filter by Weight", categoryName: "cargoDetails", eventKey: "11", key: "weight", type: filterType.boxFilter, label: "Weight" },
    { heading: "Filter by Number of Containers", categoryName: "freightType", eventKey: "12", key: "containers", type: filterType.boxFilter, label: "Number of Containers" },
    { heading: "Filter by TEUs", categoryName: "cargoDetails", eventKey: "13", key: "teu", type: filterType.boxFilter, label: "TEUs", viewAllPlaceHolder: "Search in TEUs Filter" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "14", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search Product Category", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search Industry Group", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "14", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Type to Search HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "25", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value", viewAllPlaceHolder: "Search Shipment Value", upgradeText: "To access Conatiner Load filters you need to upgrade to higher plan." },
    { heading: "Filter by Is Containerised", categoryName: categoryType.freightType, eventKey: "32", key: "transportation", type: filterType.normalFilter, label: "Is Containerised", viewAllPlaceHolder: "Search Is Containerised", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Is Containerised filters you need to upgrade to higher plan.", showInput: false },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Vessel Type", categoryName: categoryType.freightType, eventKey: "27", key: "vesselTypeRegion", altKey: "vesselType", type: filterType.localizeFilter, label: "Vessel Type", viewAllPlaceHolder: "Search Vessel Type", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by NVOCC", categoryName: "carrierDetails", eventKey: "28", key: "standardNvoccName", type: filterType.normalFilter, label: "NVOCC", viewAllPlaceHolder: "Search NVOCC Name", emptyFilterText: "", searchFilterString: "", isFavourite: true, profileTypeKey: profileType.logistics, isParanthesesCapital: true },
    { heading: "Filter by Freight Forwarder", categoryName: "carrierDetails", eventKey: "29", key: "standardFreightForwarderName", type: filterType.normalFilter, label: "Freight Forwarder", viewAllPlaceHolder: "Search Freight Forwarder Name", emptyFilterText: "", searchFilterString: "", isFavourite: true, profileTypeKey: profileType.logistics, isParanthesesCapital: true },
    { heading: "Filter by Trade Lanes", categoryName: categoryType.ports, eventKey: "30", key: "standardTradeLane", type: filterType.normalFilter, label: "Trade Lanes", viewAllPlaceHolder: "Search Trade Lane", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: true, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "derived_bol_number_with_scac", label: "Master Bill of Lading" },
    { key: "derived_hs_codes", label: "HS Code" },
    { key: "derived_product_keywords", label: "Product Keywords" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Name" },
    { key: "derived_estimated_hs_code", label: "Estimated HS Code" },
    { key: "shipper_address", label: "Shipper Address" },
    { key: "derived_carrier_name", label: "Carrier Name" },
    { key: "carrier_name", label: "Carrier Name" },
    { key: "vessel_name", label: "Vessel Name" },
    { key: "voyage_identification_number", label: "Voyage Identification Number" },
    { key: "cargo_description", label: "Cargo Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "imo_number", label: "IMO Number" },
    { key: "mmsi_number", label: "MMSI Number" },
    { key: "derived_vocc_name_id_combined", label: "VOCC" },
    { key: "derived_freight_forwarder_name_id_combined", label: "Freight Forwarder" },
    { key: "derived_nvocc_name_id_combined", label: "NVOCC" },
    { key: "derived_departure_port_name", label: "Port of Lading" },
    { key: "derived_arrival_port_name", label: "Port of Unlading" },
  ],
  shipmentSorting: [
    { columnKey: "departure_date", value: "date", isDefault: true },
    { columnKey: "weight_kg", value: "weight", isDefault: false },
    { columnKey: "derived_shipment_value", value: "shipment_value", isDefault: false },
    { columnKey: "teu", value: "teu", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "TEUs", columnKey: "teu", value: "teu", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  logisticsSorting: [
    { name: "TEUs", columnKey: "teu", value: "teu", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  sortKeyMap: {
    date: "departure_date",
    weight: "weight_kg",
    shipment_value: "derived_shipment_value",
    teu: "teu",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    weight: "weight",
    teu: "teu",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Exported", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total TEUs", key: "total_teu", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipments Value", key: "total_value", valueSuffix: "", valuePrefix: "USD" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "derived_country_of_destination_region", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination", filterKey: "derived_country_of_destination_region", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_departure_port_name" },
    { key: "derived_departure_port_name", filterKey: "standardLadingPortRegion", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_arrival_port_name", profileType: redirectingProfileEnum.portOfLading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "derived_arrival_port_name", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", profileType: redirectingProfileEnum.portOfUnlading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "trade_port", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Port of Lading → Port of Unlading)", headerOne: "US Port of Lading", headerTwo: "Port of Unlading", keyOne: "field1Country", stateOne: "departurePortState", cityOne: "field1", cityTwo: "field2", keyTwo: "field2Country", filterOne: "filterField1", filterTwo: "filterField2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_carrier_name" },
    // { key: "trade_country", filterKey1: "derived_shipper_state_region", filterKey2: "derived_country_of_destination_region", label: "Trade Routes (Shipper State → Country of Import)", headerOne: "Shipper State", headerTwo: "Country of Import", cityOne: "field1", keyOne: "field1Country", keyTwo: "field2Country", filterOne: "filterField1", filterTwo: "filterField2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_carrier_name" },
    { key: "derived_vocc_name", filterKey: "standardVoccName", label: "VOCC", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", profileType: redirectingProfileEnum.vocc.key, profileTypeKey: profileType.logistics, isFavourite: true },
    { key: "derived_nvocc_name", filterKey: "standardNvoccName", label: "NVOCC", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", profileType: redirectingProfileEnum.nvocc.key, profileTypeKey: profileType.logistics, isFavourite: true },
    { key: "derived_carrier_name", filterKey: "carrier_name", label: "Carriers", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "derived_shipper_state", headerLabel: "Section", filterKey: "derived_shipper_state_region", label: "Shipper States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_freight_forwarder_name", filterKey: "standardFreightForwarderName", label: "Freight Forwarder", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", modalHeader: "Freight Forwarder", profileType: redirectingProfileEnum.freightForwarder.key, profileTypeKey: profileType.logistics, isFavourite: true },
    // { key: "derived_trade_lane", filterKey1: "standardTradeLane", filterKey2: "standardTradeLane", label: "Top Trade Lanes(Lading Region → Unlading Region)", headerOne: "Lading Region", headerTwo: "Unlading Region", keyOne: "key1fullform", keyTwo: "key2fullform", filterOne: "filterKey", filterTwo: "filterKey", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Top Trade Lanes(Lading Region → Unlading Region)", profileType: redirectingProfileEnum.tradeLane.key, cityOne: "key1", cityTwo: "key2", profileTypeKey: profileType.tradeLanes, isFavourite: true },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "departure_date", name: "Departure Date", selector: "departure_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_codes", name: "HS Code", selector: "derived_hs_codes", alternateSelector: "derived_estimated_hs_code", dataTip: "", type: "", grow: 1, wrap: true, isInfoText: true, infoText: "HS Code for some shipments may be estimated based on the shipment data. For differentiation between actual and estimated HS Code please view the Shipment Details.", miWidth: "100px", maWidth: "100px" },
    { key: "derived_product_keywords", name: "Product", selector: "derived_product_keywords", tooltipValue: "derived_product_keywords", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "100px", maWidth: "100px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, miWidth: "100px", maWidth: "100px" },
    { key: "weight_kg", name: "Weight (kg)", selector: "weight_kg", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "teu", name: "TEUs", isTeuPresent: "teu_is_present", selector: "teu", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, sortable: true, miWidth: "70px", maWidth: "70px" },
    { key: "shipper_name", name: "Shipper Name", selector: "shipper_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "derived_country_of_destination", name: "Country of Import", selector: "derived_country_of_destination", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipment_value", name: "Estimated Shipment Value (USD)", selector: "derived_shipment_value", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "150px", maWidth: "150px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true, grow: 0, wrap: true },
    { key: "shipper_company_id", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, sortable: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, sortable: true },
    { key: "teu", name: "TEUs", type: "conditionalBlur", selector: "teu", dataTip: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan.", sortable: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan.", sortable: true },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 2, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", dataTip: "", type: "", sortable: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", dataTip: "", type: "", sortable: true },
    { key: "teu", name: "TEUs", selector: "teu", dataTip: "", type: "", sortable: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", dataTip: "", type: "conditionalBlur", grow: 1, sortable: true, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  logisticsTableColumn: [
    { key: "id", showUiUeTwoLevel: true, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", id: "hashed_id", type: "companyRedirect", grow: 1, fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, isFirstLetterCapital: true, minWidth: "200px" },
    { key: "company_type", name: "Type", type: "conditionalBlur", selector: "company_type", wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan." },
    { key: "doc_count", name: "Shipment Occurence", selector: "doc_count", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, sortable: true },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "derived_country_of_origin", showUiUeTwoLevel: false, name: "Country", selector: "country", dataTip: "", type: "", grow: 1, wrap: true, isFirstLetterCapital: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Departure", value: "departure_date", dateFormat: true, monthFormat: false },
        { label: "Master Bill of Lading", value: "derived_bol_number_with_scac", capitalize: true },
        { label: "Bill of Lading Source", value: "derived_aes_dis_type", capitalize: true },
        { label: "Is Containerised", value: "derived_is_containerised" },
        {
          label: "Estimated HS Code",
          value: "derived_estimated_hs_code",
          isConditionalField: true,
          conditionalComponentData: [
            {
              dependentField: "derived_hs_codes",
              mappingField: "derived_hs_codes",
              infoText: "",
              isHSCodeFormatter: true,
              label: "HS Code",
              isReadMore: true,
              readMoreLength: 65,
              hideField: false,
            },
            {
              dependentField: "derived_estimated_hs_code",
              mappingField: "derived_estimated_hs_code",
              infoText: "These HS Code(s) have been estimated based on the shipment data.",
              isHSCodeFormatter: true,
              label: "Estimated HS Code",
              isReadMore: true,
              readMoreLength: 65,
              isThunderIcon: true,
            },
            {
              dependentField: "",
              mappingField: "",
              infoText: "Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.",
              isHSCodeFormatter: false,
              label: "HS Code",
              isReadMore: false,
              readMoreLength: 0,
              isThunderIcon: false,
            },
          ],
        },
        { label: "Product Keywords", value: "derived_product_keywords", isReadMore: true, readMoreLength: 160 },
        { label: "Estimated Shipment Value", value: "derived_shipment_value", isThunderIcon: true, valuePrefix: "USD ", isCommaFormat: true, fixedValueUpto: 2, infoText: "Shipment Value", hideField: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Trade Lanes", value: "derived_index_tradelanes_combined", hideField: true, type: "redirect", redirectionID: "derived_trade_lane_id_combined", profileType: redirectingProfileEnum.tradeLane.key, capitalize: true },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Port of Lading", value: "derived_departure_port_name", tooltip: true, tooltipField: "departure_port_code", tooltipPrefix: "Departure Port Code: ", isCapitalise: true, type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Shipper Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "shipper_name", tradeDirection: "E", isCapitalise: true },
        { label: "Shipper Type", value: "derived_is_exporter" },
        { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
        { label: "Shipper Address", value: "shipper_address", isCapitalise: true, isReadMore: true, readMoreLength: 45 },
        { label: "Shipper State", value: "derived_shipper_state" },
        { label: "Shipper City", value: "derived_shipper_city" },
        { label: "Shipper Zip Code", value: "derived_shipper_zipcode" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code", tooltip: true, tooltipField: "derived_country_of_destination_code", tooltipPrefix: "Country of Import Code: " },
        { label: "Port of Unlading", value: "derived_arrival_port_name", tooltip: true, tooltipField: "arrival_port_code", tooltipPrefix: "Port of Unlading Code: ", isCapitalise: true, type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
      ],
    },
    {
      id: 4,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "VOCC", value: "derived_vocc_master_name", tooltip: true, tooltipField: "derived_vocc_code", tooltipPrefix: "VOCC Code: ", isCapitalise: true, type: "redirect", redirectionID: "derived_vocc_name_id_combined", profileType: redirectingProfileEnum.vocc.key },
        { label: "NVOCC", value: "derived_nvocc_master_name", tooltip: true, tooltipField: "derived_nvocc_code", tooltipPrefix: "NVOCC Code: ", isCapitalise: true, type: "redirect", redirectionID: "derived_nvocc_name_id_combined", profileType: redirectingProfileEnum.nvocc.key },
        { label: "Freight Forwarder", value: "derived_freight_forwarder_master_name", type: "redirect", redirectionID: "derived_freight_forwarder_name_id_combined", profileType: redirectingProfileEnum.freightForwarder.key },
        { label: "Carrier Name", value: "derived_carrier_name", isCapitalise: true, infoText: "Carrier Name", tooltip: true, tooltipField: "carrier_scac_code", tooltipPrefix: "Carrier SCAC Code: " },
        { label: "Vessel Name", value: "vessel_name", isCapitalise: true },
        { label: "Vessel Type", value: "vessel_type" },
        { label: "Vessel IMO Number", value: "imo_number", preValidate: true },
        { label: "Vessel MMSI Number", value: "mmsi_number", preValidate: true },
        { label: "Voyage Identification No.", value: "voyage_identification_number", isCapitalise: true },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit", isCommaFormat: true },
        { label: "Weight", value: "weight_kg", isCommaFormat: true, valueSuffix: " kg" },
        { label: "Weight (org. unit)", value: "original_weight", dynamicUnit: true, unitField: "original_weight_unit", isCommaFormat: true },
        { label: "TEUs", value: "teu", isCommaFormat: true },
        { label: "Number of Containers", value: "derived_no_of_containers", isCommaFormat: true },
      ],
    },
    {
      id: 6,
      title: "Container Details",
      growValue: 12,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Container Number", value: "container_id", capitalize: "true", isSplitNecessary: true },
        { label: "HS Code", value: "derived_hs_codes_string", isReadMoreHSCode: true, readMoreLength: 65 },
        { label: "Cargo Description", value: "cargo_description", isCapitalise: true },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment departure date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for US Exports Shipments", description: "Entire Master Bill of Lading, HS Codes, Product Description, and Shippers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  weightFilterList: ["containers"],
  specialTooltipKeywords: {
    shipper_zipcode: "Buyer Zip Code",
  },
  mappedValue: { N: "Logistics Provider", Y: "Shipper" },
  defaultUeUiSecondLevelKey: "derived_country_of_destination",
  defaultSecondLevelLogisticsTabKey: "derived_country_of_destination",

  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    derived_arrival_port_name: "Ports of Unlading",
    derived_departure_port_name: "Ports of Lading",
    derived_shipper_state: "US Shipper States",
    derived_carrier_name: "Carriers",
    derived_vocc_name: "VOCC",
    trade_port: "Trade Routes (US Port of Lading → Port of Unlading)",
    // trade_country: "Trade Routes (Shipper State → Country of Import)",

    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination: "Countries of Import",
    six_digit_hs_code: "6 digit HS Codes",
    derived_freight_forwarder_name: "Freight Forwarders",
  },
};

const UsExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default UsExportSearch;
